import { createSelector } from 'reselect';
export var getLocalitiesRoot = function (state) { return state.location.localities; };
export var getLocalities = createSelector(getLocalitiesRoot, function (localities) { return localities.data; });
export var getLocalitiesSearch = createSelector(getLocalitiesRoot, function (localities) { return localities.search; });
export var getIsLocalitiesLoading = createSelector(getLocalitiesRoot, function (localities) { return localities.isLoading; });
export var getLocalitiesError = createSelector(getLocalitiesRoot, function (localities) { return localities.error; });
